import { render, staticRenderFns } from "./backoffice-suprimentos.vue?vue&type=template&id=2dc10179&scoped=true"
import script from "./backoffice-suprimentos.vue?vue&type=script&lang=ts"
export * from "./backoffice-suprimentos.vue?vue&type=script&lang=ts"
import style0 from "./backoffice-suprimentos.vue?vue&type=style&index=0&id=2dc10179&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc10179",
  null
  
)

export default component.exports